import { httpService } from "./HttpService";
import ApiPaths from "./ApiPaths";
import { License } from "../models/License";
import { LicenseCreateRequest } from "../models/LicenseCreateRequest";
import { LicenseEditRequest } from "../models/LicenseEditRequest";

export const listAllLicenses = async (): Promise<License[]> => {
    try {
        const response = await httpService.get<License[]>(ApiPaths.GET_ALL_LICENSES);
        return response.data;
    } catch (error) {
        console.error('Error fetching licenses:', error);
        throw error;
    }
}

export const createLicense = async (license: LicenseCreateRequest): Promise<void> => {
    try {
        await httpService.post(ApiPaths.CREATE_LICENSE, license);
    } catch (error) {
        console.error('Error creating license:', error);
        throw error;
    }
}

export const editLicense = async (licenseId: string, license: LicenseEditRequest): Promise<void> => {
    try {
        await httpService.put(`${ApiPaths.EDIT_LICENSE}/${licenseId}`, license);
    } catch (error) {
        console.error('Error editing license:', error);
        throw error;
    }
}